import styles from "./styles.module.scss";
import {
  AnalysisLstatLogsGraphInterface
} from "../../../interfaces/fe.interfaces";

export interface AnalysisLstatGraphsProps {
  graphs: [AnalysisLstatLogsGraphInterface][];
}

const AnalysisLstatGraphs = ({ graphs }: AnalysisLstatGraphsProps) => {
  return (
    <div className={styles.wisaAnalysisLstatGraphsContainer}>
      <h2>Analysis Lstat Graphs</h2>
      <div>
        {
          graphs.map((graphBatch, index) => (
            <AnalysisLstatGraphsRenderBatch
              key={index}
              graphs={graphBatch}
            />
          ))
        }
      </div>
    </div>
  );
};

export interface AnalysisLstatGraphsRenderBatchProps {
  graphs: AnalysisLstatLogsGraphInterface[]
}
export function AnalysisLstatGraphsRenderBatch({ graphs }: AnalysisLstatGraphsRenderBatchProps) {
  return (
    <div>
      <p>
        {graphs[0].version}
      </p>
      <div className={styles.wisaAnalysisLstatGraphsGridContainer}>
        {
          graphs.map((batch, index) => (
            <AnalysisLstatGraphsRenderGraph
              key={`${index}-${batch.batch_id}`}
              graph={batch}
            />
          ))
        }
      </div>
    </div>
  );
}

export interface AnalysisLstatGraphsRenderGraphProps {
  graph: AnalysisLstatLogsGraphInterface
}
export function AnalysisLstatGraphsRenderGraph({ graph }: AnalysisLstatGraphsRenderGraphProps) {
  return (
    <div>
      <img
        src={`${graph.folder_path}/${graph.graph_file_name}`}
        alt={graph.graph_file_name}
        width={250}
      />
    </div>
  );
}

export default AnalysisLstatGraphs;
